import { Taxonomy } from 'app/model/taxonomy';
import { ModelPrepped, ModelWithoutId } from 'app/type';

import { RestfulApiService } from './restful-api.service';
import { Brand } from '../model/cris/brand';

class BrandService extends RestfulApiService<Brand> {
    public loadPossibleAttributes() {
        return this.http.get<string[]>(`${this.getUrl()}/attrs`);
    }

    public deploy(entity: Brand) {
        return this.http.post<string[]>(`${this.getAlterUrl(entity)}/deploy`);
    }

    public moveTaxonomy(entity: Brand, taxonomy: Taxonomy) {
        return this.http.post(`${this.getAlterUrl(entity)}/move-taxonomy`, { move_taxonomy: { taxonomy } });
    }

    protected getFormName(): string {
        return 'brand';
    }

    protected getPath(): string {
        return 'brands';
    }

    protected prepareSaveData(entity: ModelWithoutId<Brand>): ModelPrepped<Brand> {
        const { id, name, category, midCount, locationId } = entity;

        return { id, name, category, midCount, locationId };
    }
}

export const brandService = new BrandService();
